import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { get, values } from 'lodash'

import Layout from '../../components/Layout'
import SuiteMenus from '../../containers/Suite/Menus'

import { getSelectedSuites } from '../../store/Suite/selector'

export const SuiteMenusPage = ({ eventId, suiteNames, editPageType }) => {
  return (
    <Layout
      isSidebar={true}
      subtitle={suiteNames}
      title={`Update ${editPageType}`}
      backTo={`/events/${eventId}`}
      iconType="close"
    >
      <SuiteMenus />
    </Layout>
  )
}

const mapStateToProps = (state, ownProps) => {
  const eventId = get(ownProps, 'match.params.eventId')
  const editPageType =
    get(ownProps, 'match.params.customerOrAttendant') === 'customers' ? 'Customer' : 'Staff'
  const suiteNames = values(getSelectedSuites(state)).join(', ')
  return { eventId, suiteNames, editPageType }
}

export default withRouter(connect(mapStateToProps, null)(SuiteMenusPage))
